<template>
  <div>
    <jiesuan  :order_type="0" > </jiesuan> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import jiesuan from '../../tongyong/jiesuan.vue';
 
export default {

  components: {
    jiesuan: jiesuan 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
